import { ACTION_HIGHLIGHTS_FAIL, ADD_COMMENT_ACTION_HIGHLIGHTS, ADD_DESCRIPTION_ACTION_HIGHLIGHTS, ADD_DESCRIPTION_BULK_ACTION_HIGHLIGHTS, CREATE_ACTION_HIGHLIGHTS, CREATE_ACTION_HIGHLIGHTS_SUCCESS, CREATE_BC_DONE_HIGHLIGHTS, CREATE_BC_DONE_HIGHLIGHTS_SUCCESS, DELETE_ACTION, DELETE_ACTION__MULTIPLE_HIGHLIGHTS, DELETE_ACTION_HIGHLIGHTS, DELETE_ACTION_HIGHLIGHTS_SUCCESS, DELETE_ACTION_MULTIPLE_HIGHLIGHTS_SUCCESS, DELETE_ACTION_SUCCESS, DELETE_COMMENT_ACTION_HIGHLIGHTS, EDIT_ACTION_HIGHLIGHTS, EDIT_ACTION_HIGHLIGHTS_SUCCESS, EDIT_ACTION_PAYLOAD, EDIT_ACTION_PAYLOAD_SUCCESS, EDIT_COMMENT_ACTION_HIGHLIGHTS, GET_ACTION_BY_ID, GET_ACTION_BY_ID_SUCCESS, GET_ACTION_HIGHLIGHTS_BY_IDS, GET_ACTION_HIGHLIGHTS_BY_IDS_SUCCESS, GET_ALL_ACTION_BY_NAME, GET_ALL_ACTION_BY_NAME_SUCCESS, GET_ALL_ACTIVE_ACTION_BY_NAME, GET_ALL_ACTIVE_ACTION_BY_NAME_SUCCESS, GET_ALL_BC_PC_REV_STAGES, GET_ALL_BC_PC_REV_STAGES_SUCCESS, GET_ALL_DELIVER_CHECKLIST, GET_ALL_DELIVER_CHECKLIST_SUCCESS, GET_ALL_DELIVERIES, GET_ALL_DELIVERIES_SUCCESS, GET_ALL_TEMPLATES, GET_ALL_TEMPLATES_SUCCESS, GET_EXCEL_REPORT, GET_EXCEL_REPORT_SUCCESS, REMOVE_HIGHLIGHTER, REMOVE_HIGHLIGHTER_FROM_PROJECTVIEW, REMOVE_HIGHLIGHTER_FROM_PROJECTVIEW_SUCCESS, REMOVE_HIGHLIGHTER_FROM_TASKVIEW, REMOVE_HIGHLIGHTER_FROM_TASKVIEW_SUCCESS, REMOVE_HIGHLIGHTER_SUCCESS, UPDATE_DELIVERY_ROW } from "../storeTypes";

const initialState: any = {
  actionHighlights: null,
  loader: false,
  error: null,
  createHighlight: null,
  deliverChecklist: null,
  templateList: null,
  bcActionDone: null,
  removeHighlights: null,
  removeHighlightsTask: null,
  removeHighlightsProject: null,
  actionnameList: null,
  activeactionnameList: null,
  bcpcactionnameList: null,
  isLoader: false,
  excelReport: null,
  BcPclist: null,
  allDeliveries: null

};

const ActionHighlight = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ACTION_HIGHLIGHTS_BY_IDS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_ACTION_HIGHLIGHTS_BY_IDS_SUCCESS: {
      return {
        ...state,
        loader: false,
        actionHighlights: action.payload
      };
    }
    case GET_ACTION_BY_ID: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_ACTION_BY_ID_SUCCESS: {
      return {
        ...state,
        loader: false,
        actionHighlights: action.payload
      };
    }
    case GET_ALL_ACTION_BY_NAME: {
      return {
        ...state,
        loader: true,
        isLoader: true,
        actionnameList: null
      };
    }
    case GET_ALL_ACTION_BY_NAME_SUCCESS: {
      return {
        ...state,
        loader: false,
        isLoader: false,
        actionnameList: action.payload
      };
    }
    case GET_ALL_ACTIVE_ACTION_BY_NAME: {
      return {
        ...state,
        loader: true,
        isLoader: true,
        activeactionnameList: null
      };
    }
    case GET_ALL_ACTIVE_ACTION_BY_NAME_SUCCESS: {
      return {
        ...state,
        loader: false,
        isLoader: false,
        activeactionnameList: action.payload
      };
    }
    case GET_ALL_BC_PC_REV_STAGES: {
      return {
        ...state,
        loader: true,
        isLoader: true,
        BcPclist: null
      };
    }
    case GET_ALL_BC_PC_REV_STAGES_SUCCESS: {
      return {
        ...state,
        loader: false,
        isLoader: false,
        BcPclist: action.payload
      };
    }
    case GET_ALL_DELIVER_CHECKLIST: {
      return {
        ...state,
        loader: true,
        deliverChecklist: null
      };
    }
    case GET_ALL_DELIVER_CHECKLIST_SUCCESS: {
      return {
        ...state,
        loader: false,
        deliverChecklist: action.payload
      };
    }
    case REMOVE_HIGHLIGHTER: {
      return {
        ...state,
        loader: true,
      };
    }
    case REMOVE_HIGHLIGHTER_SUCCESS: {
      return {
        ...state,
        loader: false,
        removeHighlights: action.payload
      };
    }
    case REMOVE_HIGHLIGHTER_FROM_TASKVIEW: {
      return {
        ...state,
        loader: true,
      };
    }
    case REMOVE_HIGHLIGHTER_FROM_TASKVIEW_SUCCESS: {
      return {
        ...state,
        loader: false,
        removeHighlightsTask: action.payload
      };
    }
    case REMOVE_HIGHLIGHTER_FROM_PROJECTVIEW: {
      return {
        ...state,
        loader: true,
      };
    }
    case REMOVE_HIGHLIGHTER_FROM_PROJECTVIEW_SUCCESS: {
      return {
        ...state,
        loader: false,
        removeHighlightsProject: action.payload
      };
    }
    case GET_ALL_TEMPLATES: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_ALL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        loader: false,
        templateList: action.payload
      };
    }
    case CREATE_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
        isLoader: true
      };
    }
    case CREATE_ACTION_HIGHLIGHTS_SUCCESS: {
      const doc = action.payload?.data?.actionType ? action.payload.data : (action.payload?.actionType ? action.payload : null);
      return {
        ...state,
        loader: false,
        isLoader: false,
        createHighlight: action.payload,
        actionHighlights: doc || state.actionHighlights
      }
    }
    case CREATE_BC_DONE_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case CREATE_BC_DONE_HIGHLIGHTS_SUCCESS: {
      return {
        ...state,
        loader: false,
        bcActionDone: action.payload
      }
    }
    case EDIT_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case EDIT_ACTION_HIGHLIGHTS_SUCCESS: {
      const doc = action.payload?.data?.actionType ? action.payload.data : (action.payload?.actionType ? action.payload : null);
      let updatedHighlights = state.actionHighlights;

      if (doc) {
        updatedHighlights = doc;
      } else if (state.actionHighlights?.payload?.Description && action.payload?.reqPayload) {
        const { name, data: updatedFields, id: editItemId, _id: editItem_id } = action.payload.reqPayload;
        const targetItemId = editItemId || editItem_id;
        if ((targetItemId || name) && updatedFields) {
          let updatedOnce = false;
          const newDesc = state.actionHighlights.payload.Description.map((item: any) => {
            if (targetItemId) {
              if (item._id === targetItemId || item.id === targetItemId) {
                return { ...item, ...updatedFields };
              }
            } else if (!updatedOnce && (item.name === name || (item._id && item._id === name))) {
              updatedOnce = true;
              return { ...item, ...updatedFields };
            }
            return item;
          });
          updatedHighlights = {
            ...state.actionHighlights,
            payload: {
              ...state.actionHighlights.payload,
              Description: newDesc
            }
          };
        }
      }
      return {
        ...state,
        loader: false,
        actionHighlights: updatedHighlights
      }
    }
    case ADD_DESCRIPTION_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: false,
      };
    }
    case ADD_DESCRIPTION_BULK_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: false,
      };
    }
    case EDIT_ACTION_PAYLOAD: {
      return {
        ...state,
        loader: false,
      };
    }
    case EDIT_ACTION_PAYLOAD_SUCCESS: {
      const doc = action.payload?.data?.actionType ? action.payload.data : (action.payload?.actionType ? action.payload : null);
      return {
        ...state,
        loader: false,
        actionHighlights: doc || state.actionHighlights
      }
    }
    case DELETE_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_ACTION_HIGHLIGHTS_SUCCESS: {
      const doc = action.payload?.data?.actionType ? action.payload.data : (action.payload?.actionType ? action.payload : null);
      let updatedHighlights = state.actionHighlights;

      if (doc) {
        updatedHighlights = doc;
      } else if (state.actionHighlights?.payload?.Description && action.payload?.reqPayload?.id) {
        const deleteId = action.payload.reqPayload.id;
        const newDesc = state.actionHighlights.payload.Description.filter((item: any) =>
          item.name !== deleteId && item._id !== deleteId
        );
        updatedHighlights = {
          ...state.actionHighlights,
          payload: {
            ...state.actionHighlights.payload,
            Description: newDesc
          }
        };
      }
      return {
        ...state,
        loader: false,
        actionHighlights: updatedHighlights
      }
    }
    case DELETE_ACTION: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_ACTION_SUCCESS: {
      return {
        ...state,
        loader: false,
        bcpcactionnameList: action.payload
      }
    }
    case DELETE_ACTION__MULTIPLE_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_ACTION_MULTIPLE_HIGHLIGHTS_SUCCESS: {
      return {
        ...state,
        loader: false,
        createHighlight: action.payload
      }
    }
    case ADD_COMMENT_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case EDIT_COMMENT_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_COMMENT_ACTION_HIGHLIGHTS: {
      return {
        ...state,
        loader: true,
      };
    }
    case ACTION_HIGHLIGHTS_FAIL: {
      return {
        ...state,
        loader: false,
        error: action.payload
      };
    }
    case GET_EXCEL_REPORT: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_EXCEL_REPORT_SUCCESS: {
      return {
        ...state,
        loader: false,
        excelReport: action.payload
      };
    }
    case GET_ALL_DELIVERIES: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_ALL_DELIVERIES_SUCCESS: {
      return {
        ...state,
        loader: false,
        allDeliveries: action.payload
      };
    }
    case UPDATE_DELIVERY_ROW: {
      const payload = action?.payload;
      const targetId = String(payload?.id || payload?.data?._id || '');
      const type = payload?.type || 'Update';

      if (!state.allDeliveries) {
        return state;
      }

      const isArrayFormat = Array.isArray(state.allDeliveries);
      const currentList: any[] = isArrayFormat
        ? state.allDeliveries
        : (Array.isArray(state.allDeliveries.data) ? state.allDeliveries.data : []);

      let updatedList = [...currentList];

      if (type === 'Delete') {
        updatedList = updatedList.filter(
          (item: any) => String(item?._id || item?.id || '') !== targetId
        );
      } else if (type === 'Insert') {
        if (payload?.data && !updatedList.some((item: any) => String(item?._id || item?.id || '') === targetId)) {
          updatedList = [payload.data, ...updatedList];
        }
      } else {
        updatedList = updatedList.map((item: any) => {
          const itemId = String(item?._id || item?.id || '');
          if (itemId === targetId) {
            if (!payload?.data) return item;
            const merged = { ...item, ...payload.data };
            if (payload?.data?.projectId && typeof payload.data.projectId === 'object' && 'name' in payload.data.projectId) {
              merged.projectId = { ...(typeof item.projectId === 'object' ? item.projectId : {}), ...payload.data.projectId };
            } else if (item.projectId && typeof item.projectId === 'object' && 'name' in item.projectId) {
              const nextProjId = typeof payload.data.projectId === 'object' && payload.data.projectId !== null
                ? String(payload.data.projectId._id || '')
                : String(payload.data.projectId || '');
              const prevProjId = String(item.projectId._id || item.projectId.id || '');
              if (!nextProjId || nextProjId === prevProjId) {
                merged.projectId = item.projectId;
              }
            }
            if (payload?.data?.stageId && typeof payload.data.stageId === 'object' && ('name' in payload.data.stageId || 'color' in payload.data.stageId)) {
              merged.stageId = { ...(typeof item.stageId === 'object' ? item.stageId : {}), ...payload.data.stageId };
            } else if (item.stageId && typeof item.stageId === 'object' && ('name' in item.stageId || 'color' in item.stageId)) {
              const nextStageId = typeof payload.data.stageId === 'object' && payload.data.stageId !== null
                ? String(payload.data.stageId._id || '')
                : String(payload.data.stageId || '');
              const prevStageId = String(item.stageId._id || item.stageId.id || '');
              if (!nextStageId || nextStageId === prevStageId) {
                merged.stageId = item.stageId;
              }
            }
            if (payload?.data?.manager && typeof payload.data.manager === 'object' && ('FirstName' in payload.data.manager || 'LastName' in payload.data.manager)) {
              merged.manager = { ...(typeof item.manager === 'object' ? item.manager : {}), ...payload.data.manager };
            } else if (item.manager && typeof item.manager === 'object' && ('FirstName' in item.manager || 'LastName' in item.manager)) {
              const nextManagerId = typeof payload.data.manager === 'object' && payload.data.manager !== null
                ? String(payload.data.manager._id || '')
                : String(payload.data.manager || '');
              const prevManagerId = String(item.manager._id || item.manager.id || '');
              if (!nextManagerId || nextManagerId === prevManagerId) {
                merged.manager = item.manager;
              }
            }
            if (payload?.data?.cadOperator && typeof payload.data.cadOperator === 'object' && ('FirstName' in payload.data.cadOperator || 'LastName' in payload.data.cadOperator)) {
              merged.cadOperator = { ...(typeof item.cadOperator === 'object' ? item.cadOperator : {}), ...payload.data.cadOperator };
            } else if (item.cadOperator && typeof item.cadOperator === 'object' && ('FirstName' in item.cadOperator || 'LastName' in item.cadOperator)) {
              const nextCadId = typeof payload.data.cadOperator === 'object' && payload.data.cadOperator !== null
                ? String(payload.data.cadOperator._id || '')
                : String(payload.data.cadOperator || '');
              const prevCadId = String(item.cadOperator._id || item.cadOperator.id || '');
              if (!nextCadId || nextCadId === prevCadId) {
                merged.cadOperator = item.cadOperator;
              }
            }
            return merged;
          }
          return item;
        });
      }

      return {
        ...state,
        allDeliveries: isArrayFormat
          ? updatedList
          : {
            ...state.allDeliveries,
            data: updatedList,
            count:
              type === 'Delete'
                ? Math.max(0, (state.allDeliveries.count || 1) - 1)
                : type === 'Insert'
                  ? (state.allDeliveries.count || 0) + 1
                  : state.allDeliveries.count,
          },
      };
    }
    default: {
      return state;
    }
  }
};

export default ActionHighlight;